import { render, staticRenderFns } from "./InstitutionFileUpload.vue?vue&type=template&id=534c4010&scoped=true&"
import script from "./InstitutionFileUpload.vue?vue&type=script&lang=js&"
export * from "./InstitutionFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionFileUpload.vue?vue&type=style&index=0&id=534c4010&lang=scss&scoped=true&"
import style1 from "./InstitutionFileUpload.vue?vue&type=style&index=1&id=534c4010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c4010",
  null
  
)

export default component.exports